<template>
  <v-container fluid tag="section">
    <base-material-table-mobile
      outlined
      :item="item"
      :excel="excel"
      ref="table"
      @on-add='add'
      single-expand
      show-select
      mobile-show-select
      v-model="selected"
    >
      <template v-slot:foot="{ total }">
        <td  :colspan="item.headers.length">
          <div class="my-3 mx-4">
            <span class="size-13 grey--text">客户量</span>&nbsp;<span class="size-15 blue--text font-family-Impact">{{total === null ? 0 : total.customer}}</span>&nbsp;
            <span class="size-13 grey--text">订单量</span>&nbsp;<span class="size-15 orange--text font-family-Impact">{{total === null ? 0 : total.contract}}</span>&nbsp;
            <span class="size-13 grey--text">通过量</span>&nbsp;<span class="size-15 green--text font-family-Impact">{{total === null || total.itemPass === null ? 0 : total.itemPass}}</span>&nbsp;<br v-if="$isMobile">
            <span class="size-13 grey--text">签单额</span>&nbsp;<span class="size-15 teal--text font-family-Impact">{{total === null ||  total.signPrice === null ? 0 : total.signPrice }}</span>&nbsp;
            <span class="size-13 grey--text">绩效额</span>&nbsp;<span class="size-15 teal--text font-family-Impact">{{total === null ||  total.profitPrice === null ? 0 : total.profitPrice }}</span>&nbsp;<br v-if="$isMobile">
          </div>
        </td>
      </template>
      <template v-slot:condition>
        <v-col cols="6" class="pr-2 pb-0 pt-c-10 px-0">
          <base-marerial-user-select @on-change="loadData"  label='负责人' hide-details dense outlined v-model="item.params.userIds" mid :menu='$constants.SysMenu.CONTRACT_M_ID'></base-marerial-user-select>
        </v-col>
        <v-col cols="6" class="pr-2 pb-0 pt-c-10 px-0">
          <base-material-date
            hide-details
            range
            label='创建时间'
            clearable
            dense outlined
            @on-change="loadData"
            v-model="item.params.createTimes"
            clear-icon="mdi-close-circle-outline"
          >
          </base-material-date>
        </v-col>
        <v-col cols="12" class="pr-2 pb-0 pt-c-10 px-0">
          <base-material-date
            dense outlined
            hide-details
            range
            label='签订时间'
            clearable
            @on-change="loadData"
            v-model="item.params.signTimes"
            clear-icon="mdi-close-circle-outline"
          >
          </base-material-date>
        </v-col>
      </template>
      <template v-slot:actions>
        <v-btn depressed dark small color="cyan" @click="batchInvoice" class="mx-1 px-2">
          <v-icon size="20" dark>mdi-file-check-outline</v-icon>合并开票
        </v-btn>
      </template>
      <template v-slot:expanded-content="{ item }">
        <v-divider></v-divider>
        <detail-view :item='item' show-arrows></detail-view>
      </template>
    </base-material-table-mobile>
    <v-snackbar v-model="tip.show" timeout='3000' centered rounded="pill" color="warning">
      <span :class="$isMobile ? 'size-12' : 'size-20'">!&nbsp;{{ tip.text }}</span>
      <template v-slot:action="{ attrs }">
        <v-btn text fab v-bind="attrs" small @click="tip.show = false"><v-icon>mdi-close</v-icon></v-btn>
      </template>
    </v-snackbar>
    <add-view :item='addModal' @on-load-data='loadData'></add-view>
    <later-view :item='laterModal' @on-load-data='loadData'></later-view>
    <again-view :item='againModal' @on-load-data='loadData'></again-view>
    <collect-add :item='collectAddModal' :surplus-money='surplusMoney' @on-load-data='loadData'></collect-add>
    <return-add :item='returnAddModal' :surplus-money='surplusMoney' @on-load-data='loadData'></return-add>
    <order-add :item='orderAddModal' @on-load-data='loadData'></order-add>
    <invoice-add ref="invoice" :item='invoiceAddModal' :surplus-money='surplusMoney' @on-load-data='loadData'></invoice-add>
    <invoice-batch-add  :item='invoiceBatchAddModal' @on-load-data='loadData'></invoice-batch-add>
    <refund-add :item='refundAddModal' :surplus-money='surplusMoney' @on-load-data='loadData'></refund-add>
  </v-container>
</template>

<script>
  import { getByPids } from '@/api/system/dictionary.js'
  import { fmAuditColor, serialNumber } from '@/utils/stringUtil.js'
  import { selectData } from '@/utils/tool.js'
  import { update } from '@/api/contract/index.js'
  import CollectAdd from '@/views/pages/pc/contract/collect/components/Add.vue'
  import InvoiceAdd from '@/views/pages/pc/contract/invoice/components/Add.vue'
  import InvoiceBatchAdd from '@/views/pages/pc/contract/invoice/components/BatchAdd.vue'
  import RefundAdd from '@/views/pages/pc/contract/refund/components/Add.vue'
  import ReturnAdd from '@/views/pages/pc/contract/returned/components/Add.vue'
  import OrderAdd from '@/views/pages/pc/order/info/components/Add.vue'
  import VSelectSearch from '@/components/select/v-select-search.vue'
  import AddView from './components/Add'
  import LaterView from './components/Later'
  import AgainView from './components/Again'
  import DetailView from './Detail.vue'

  export default {
    name: 'ContractIndex',
    components: {
      AddView,
      DetailView,
      CollectAdd,
      ReturnAdd,
      OrderAdd,
      InvoiceAdd,
      RefundAdd,
      LaterView,
      VSelectSearch,
      InvoiceBatchAdd,
      AgainView
    },
  data() {
      return {
        tab: 0,
        tip: { show: false, text: '' },
        loading: false,
        selected: [],
        addModal: { show: false, data: {} },
        againModal: { show: false, data: {} },
        laterModal: { show: false, data: {} },
        orderAddModal: { show: false, data: {} },
        invoiceAddModal: { show: false, data: {} },
        invoiceBatchAddModal: { show: false, data: {} },
        refundAddModal: { show: false, data: {} },
        collectAddModal: {
          contractId: '', data: [], show: false, type: 1
        },
        returnAddModal: {
          contractId: '', data: [], show: false, type: 1
        },
        stateItems: [],
        surplusMoney: 0,
        item: {
          path: 'contract/info/list',
          total: true,
          mobile: true,
          sort: {
            orderByField: 'create_time',
            asc: false
          },
          topButtons: [
            { event: 'search', show: true },
            { event: 'download', show: this.$_has('con-contract-info-down') },
            { event: 'add', show: this.$_has('con-contract-info-add') }
          ],
          params: {
            userIds: [],
            invoiceType: '',
            createTimes: [],
            productIds: [],
            version: '',
            signTimes: [],
            contactsAddress: ''
          },
          headers: [
            {
              text: '详情',
              align: 'center',
              divider: true,
              width: 60,
              class: 'fixed-left',
              cellClass: 'fixed-left',
              value: '',
              sortable: false,
              mobile: true,
              icon: {
                value: 'mdi-dots-horizontal',
                onClick: (row, idx) => {
                  this.$refs.table.showMore(row, idx)
                }
              }
            },
            {
              text: '客户名称',
              align: 'center',
              divider: true,
              width: 210,
              value: 'customer.name',
              copy: true,
              sortable: false,
              mobile: true,
              search: { type: 'input', mobile: true }
            },
            {
              text: '合同编号',
              align: 'center',
              width: 210,
              divider: true,
              value: 'serialNumber',
              copy: true,
              sortable: true,
              mobile: true,
              search: { type: 'input', mobile: true }
            },
            {
              text: '项目年份',
              hidden: true,
              value: 'year',
              mobile: true,
              search: {
                type: 'select',
                options: () => selectData(2)
              },
            },
            {
              text: '渠道名称',
              align: 'center',
              width: 100,
              hidden: true,
              value: 'channelName',
              search: {
                type: 'input'
              }
            },
            {
              text: '审核状态',
              align: 'center',
              divider: true,
              width: 100,
              value: 'order',
              sortable: false,
              mobile: true,
              chip: {
                color: (val) => fmAuditColor(val.auditStatus),
                formatter: (val) => val.auditStatusVal
              },
              search: {
                type: 'select',
                secKey: 'auditStatus',
                multiple: true,
                model: [0, 1],
                options: () => [
                  { label: '审核中', value: 0 },
                  { label: '已通过', value: 1 },
                  { label: '未通过', value: -1 }
                ]
              }
            },
            {
              text: '合同状态',
              align: 'center',
              width: 130,
              divider: true,
              value: 'stateDic.name',
              sortable: false,
              mobile: true,
              search: {
                type: 'select',
                itemText: 'name',
                itemValue: 'id',
                secKey: 'stateIds',
                multiple: true,
                options: () => this.stateItems
              }
            },
            {
              text: '签订项目',
              align: 'center',
              divider: true,
              width: 220,
              value: 'product.name',
              copy: true,
              mobile: true,
              sortable: false
            },
            {
              text: '签单单价',
              align: 'center',
              divider: true,
              width: 100,
              value: 'signUnitPrice',
              mobile: true,
              sortable: false
            },
            {
              text: '合同额',
              align: 'center',
              divider: true,
              width: 100,
              value: 'signPrice',
              mobile: true,
              sortable: false
            },
            {
              text: '已收款',
              align: 'center',
              divider: true,
              width: 100,
              mobile: true,
              value: 'returnedMoneys',
              sortable: false,
              formatter: (val) => {
                let money = 0.0
                val.forEach(item => {
                  if (item.order.auditStatus === 1) {
                    money += item.money
                  }
                })
                return money
              }
            },
            {
              text: '已开票',
              align: 'center',
              divider: true,
              width: 90,
              value: 'invoiceMoney',
              mobile: true,
              sortable: false
            },
            {
              text: '工单状态',
              align: 'center',
              width: 90,
              value: 'orderState',
              divider: true,
              sortable: false,
              mobile: true,
              search: {
                type: 'select',
                options: () => [
                  { label: '已发', value: 1 },
                  { label: '未发', value: 0 }
                ]
              },
              formatter: (val) => (val === 0 ? '未发' : '已发')
            },
            {
              text: '关联合同',
              align: 'center',
              divider: true,
              width: 90,
              value: 'relationNum',
              sortable: false,
              formatter: (val) => (val > 1 ? `+${val - 1}` : 0)
            },
            {
              text: '产品数量',
              align: 'center',
              width: 90,
              divider: true,
              mobile: true,
              value: 'productNumber',
              sortable: false
            },
            {
              text: '签订人',
              align: 'center',
              width: 150,
              divider: true,
              value: 'signUserList',
              mobile: true,
              sortable: false,
              formatter: (val) => {
                let name = ''
                val.forEach(item => {
                  name += `${item.name}|`
                })
                return name.substring(0, name.lastIndexOf("|"))
              }
            },
            {
              text: '签订单位',
              align: 'center',
              divider: true,
              width: 200,
              value: 'signDic.name',
              sortable: false
            },
            {
              text: '签订时间',
              align: 'center',
              divider: true,
              width: 110,
              value: 'signTime',
              sortable: false,
              mobile: true,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '创建人',
              align: 'center',
              divider: true,
              width: 110,
              value: 'createUser.name',
              sortable: false
            },
            {
              text: '创建时间',
              align: 'center',
              width: 150,
              value: 'createTime',
              sortable: true,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '操作',
              value: 'actions',
              align: 'center',
              width: 85,
              sortable: false,
              class: 'fixed-right',
              cellClass: 'fixed-right',
              mobile: true,
              menu: {
                text: '操作',
                color: 'primary',
                icon: 'mdi-menu-down-outline',
                actions: [
                  {
                    text: '编辑',
                    color: 'primary',
                    icon: 'mdi-pencil',
                    onClick: (row) => {
                      this.addModal = { show: true, relation: false, data: row }
                    },
                    disable: (row) => row.order.auditStatus === 0 || !this.$_has('con-contract-info-edit') || row.stateId === this.$constants.ContractState.UN_PASS_ID || row.stateId === this.$constants.ContractState.STOP_ID // || row.order.auditStatus === 1
                  },
                  {
                    text: '申请退款',
                    color: 'orange',
                    icon: 'mdi-firebase',
                    onClick: (row) => {
                      this.refundAddModal = { show: true, data: row }
                      this.surplusMoney = Number(row.surplusRefundMoney)
                    },
                    disable: (row) => row.order.auditStatus !== 1 || !this.$_has('con-contract-refund-add') || row.stateId !== this.$constants.ContractState.STOP_ID || Number(row.surplusRefundMoney) === 0
                  },
                  {
                    text: '续报',
                    color: 'cyan',
                    icon: 'mdi-atom-variant',
                    onClick: (row) => {
                      this.againModal = { show: true, data: row }
                    },
                    disable: (row) => row.order.auditStatus !== 1 || !this.$_has('con-contract-info-edit') || row.stateId !== this.$constants.ContractState.UN_PASS_ID
                  },
                  {
                    text: '终止',
                    color: 'red',
                    icon: 'mdi-circle-off-outline',
                    onClick: (row) => {
                      this.stop(row)
                    },
                    disable: (row) => row.order.auditStatus !== 1 || !this.$_has('con-contract-info-edit') || row.stateId !== this.$constants.ContractState.UN_PASS_ID
                  },
                  {
                    text: '工单',
                    color: 'indigo',
                    icon: 'mdi-order-bool-ascending',
                    onClick: (row) => {
                      this.orderAddModal = { show: true, data: row }
                    },
                    disable: (row) => row.order.auditStatus !== 1 || !this.$_has('order-info-add') || row.orderState === 1 || row.stateId === this.$constants.ContractState.UN_PASS_ID || row.stateId === this.$constants.ContractState.STOP_ID
                  },
                  {
                    text: '发票',
                    color: 'cyan',
                    icon: 'mdi-file-check-outline',
                    onClick: (row) => {
                      this.invoiceAddModal = { show: true, data: row }
                      this.surplusMoney = Number(row.signPrice) - Number(row.invoiceMoney)
                    },
                    disable: (row) => row.order.auditStatus !== 1 || !this.$_has('con-contract-invoice-add') || Number(row.signPrice) <= Number(row.invoiceMoney) || row.stateId === this.$constants.ContractState.STOP_ID
                  },
                  {
                    text: '回款单',
                    color: 'purple',
                    icon: 'mdi-beekeeper',
                    onClick: (row) => {
                      this.returnAddModal = { show: true, contractId: row.id, type: 1, customerName: row.customer.name }
                      this.surplusMoney = row.surplusReturnMoney
                    },
                    disable: (row) => row.order.auditStatus !== 1 || !this.$_has('con-return-money-add') || row.surplusReturnMoney <= 0 || row.stateId === this.$constants.ContractState.UN_PASS_ID || row.stateId === this.$constants.ContractState.STOP_ID
                  },
                  {
                    text: '应收款',
                    color: 'blue',
                    icon: 'mdi-calendar-weekend-outline',
                    onClick: (row) => {
                      this.collectAddModal = { show: true, contractId: row.id, type: 1 }
                      this.surplusMoney = row.surplusReturnMoney
                    },
                    disable: (row) => row.order.auditStatus !== 1 || !this.$_has('con-collect-money-add') || row.surplusReturnMoney <= 0 || row.stateId === this.$constants.ContractState.UN_PASS_ID || row.stateId === this.$constants.ContractState.STOP_ID
                  },
                  {
                    text: '后付费',
                    color: 'green',
                    icon: 'mdi-clipboard-arrow-right-outline',
                    onClick: (row) => {
                      this.laterModal = { show: true, data: row }
                    },
                    disable: (row) => row.order.auditStatus !== 1 || !this.$_has('con-contract-info-later') || (row.unitPrice === 0 && row.signPrice !== 0) || row.stateId !== this.$constants.ContractState.PASS_ID
                  },
                  {
                    text: '关联合同',
                    color: 'blue-grey',
                    icon: 'mdi-horizontal-rotate-clockwise',
                    onClick: (row) => {
                      this.addModal = { show: true, relation: true, data: row }
                    },
                    disable: (row) => row.order.auditStatus === -1
                  }
                ]
              }
            }
          ]
        },
        excel: {
          path: 'contract/info/down',
          filename: `${serialNumber()}_合同订单.xls`,
          fields: {
            客户名称: 'customer.name',
            合同状态: 'stateDic.name',
            合同单号: 'serialNumber',
            签订项目: 'product.name',
            项目年份: 'year',
            签定数量: 'productNumber',
            签定人员: {
              field: 'signUserList',
              callback: (value) => {
                let name = ''
                value.forEach(us => {
                  name += `${us.name},`
                })
                return name
              }
            },
            签订单位: 'signDic.name',
            渠道名称: 'channelName',
            签单单价: 'signUnitPrice',
            公司定价: 'product.price',
            合同类型: 'typeDic.name',
            合同金额: 'signPrice',
            合同绩效: 'profitPrice',
            提成金额: 'ratioPrice',
            提成比例: {
              field: 'commissionRatio',
              callback: (value) => `${value}%`
            },
            居间人费: 'mediatorPrice',
            其他费用: 'otherPrice',
            已收金额: {
              field: 'returnedMoneys',
              callback: (value) => {
                let money = 0
                value.forEach(mo => {
                  if (mo.order.auditStatus === 1) {
                    money += mo.money
                  }
                })
                return money
              }
            },
            未收金额: 'lastReturnMoney',
            开票金额: {
              field: 'invoiceInfos',
              callback: (value) => {
                let money = 0
                value.forEach(inv => {
                  if (inv.order.auditStatus === 1) {
                    money += inv.money
                  }
                })
                return money
              }
            },
            创建时间: {
              field: 'createTime',
              callback: (value) => this.$moment(value * 1000).format('YYYY-MM-DD')
            },
            合同版本: 'version'
          }
        }
      }
    },
    methods: {
      add () {
        this.addModal = { relation: false, show: true }
      },
      batchInvoice () {
        if (this.selected.length < 2) {
          this.tip = { show: true, text: '操作失败【至少选择两份合同】' }
          return
        }
        const customer = this.selected[0].customer.id
        for (let i = 0; i < this.selected.length; i++) {
          if (customer !== this.selected[i].customer.id) {
            this.tip = { show: true, text: '操作失败【请选择相同主体开票】' }
            return
          }
          if (this.selected[i].surplusInvoiceMoney < 1) {
            this.tip = { show: true, text: `操作失败【${this.selected[i].serialNumber}无开票额度】` }
            return
          }

          if (this.selected[i].order.auditStatus !== 1) {
            this.tip = { show: true, text: `操作失败【${this.selected[i].serialNumber}未审核通过】` }
            return
          }
        }
        this.invoiceBatchAddModal = { show: true, data: this.selected }
      },
      loadData () {
        this.$refs.table.loadData()
      },
      queryKeyDown () {
        if (window.event.keyCode === 13) {
          this.loadData()
        }
      },
      async getSelectItems () {
        await getByPids(
            {
            pids: [
              this.$constants.contractStatePid,
            ]
          }
        ).then(res => {
          if (res.status === 200) {
            const this_ = this
            res.data.forEach((result) => {
              if (this_.$constants.contractStatePid === result.id) {
                this_.stateItems = result.data
              }
            })
          }
        })
      },
      stop (row) {
        this.$dialog.confirm({
          text: `确认【终止】此合同吗?`,
          title: '系统提示',
          width: 320,
          actions: {
            false: { color: 'grey', text: '取消' },
            true: {
              color: 'primary',
              text: '确认',
              handle: () => new Promise(resolve => {
                update({ id: row.id, stateId: this.$constants.ContractState.STOP_ID }).then(response => {
                  const { status } = response
                  if (status === 200) {
                    this.loadData()
                    this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
                  }
                  resolve(response)
                })
              })
            }
          }
        })
      }
    },
    created() {
      this.getSelectItems()
    }
  }
</script>

<style>
</style>
